module.exports = {
  email: 'junyixulea@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/LeaiFish',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/junyi_gf/',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/ria_leagf',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/junyixu/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      name_zh: '关于',
      url: '/#about',
    },
    {
      name: 'Experience',
      name_zh: '经历',
      url: '/#jobs',
    },
    {
      name: 'Work',
      name_zh: '作品',
      url: '/#projects',
    },
    {
      name: 'Contact',
      name_zh: '联系',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
